// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df87e710","488":"069c88c3","732":"7f7b54ab","977":"00673bd4"}[chunkId] + ".chunk.js";
};